import { render } from "./taskPlan.vue?vue&type=template&id=85a12a4a&scoped=true"
import script from "./taskPlan.vue?vue&type=script&lang=js"
export * from "./taskPlan.vue?vue&type=script&lang=js"

import "./taskPlan.vue?vue&type=style&index=0&id=85a12a4a&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a12a4a"]])

export default __exports__